import { create } from "zustand";

interface ToastState {
  message: string | null;
  visible: boolean;
  show: (message: string) => void;
  hide: () => void;
}

let timer: ReturnType<typeof setTimeout> | undefined;

export const useToast = create<ToastState>((set) => ({
  message: null,
  visible: false,
  show: (message: string) => {
    set({ message, visible: true });
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => set({ visible: false }), 2200);
  },
  hide: () => set({ visible: false }),
}));

/** Fire a toast from anywhere (outside React too). */
export const toast = (message: string) => useToast.getState().show(message);
